// @flow
import React from 'react';

export default ({ className = '', text, ...props }) => (
  <i className={`${className} fa fa-file${text ? '-text-o' : ''}`} {...props} />
);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/theme/icons/File.js